import styled from 'styled-components';

export const Container = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 0;

  svg {
    padding: 0;
    flex-shrink: 0;
    transform: scale(0.8);
  }
`;
